import React from 'react';
import classes from './no-results-message.scss';
import { phoneText } from './no-results-message.constants';
export default function NoResultsMessage() {
  return /*#__PURE__*/React.createElement("div", {
    className: classes.container
  }, /*#__PURE__*/React.createElement("p", {
    className: classes.text
  }, "Sorry, we couldn't find anything. Please contact us through chat ", phoneText, ' ', "and we would love to help."));
}